export type Tema = 'claro' | 'escuro';

const CHAVE_TEMA = 'levitas:tema';
const CHAVE_SIMPLIFICADO = 'levitas:modo-simplificado';

function ler(chave: string): string | null {
  try {
    return localStorage.getItem(chave);
  } catch {
    return null;
  }
}

function gravar(chave: string, valor: string): void {
  try {
    localStorage.setItem(chave, valor);
  } catch {
    // Navegador com armazenamento bloqueado: o produto continua funcionando,
    // só não lembra a preferência.
  }
}

export function temaAtual(): Tema {
  const salvo = ler(CHAVE_TEMA);
  if (salvo === 'claro' || salvo === 'escuro') return salvo;
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'escuro' : 'claro';
}

export function aplicarTema(tema: Tema): void {
  document.documentElement.dataset['tema'] = tema;
  gravar(CHAVE_TEMA, tema);
}

export function alternarTema(): Tema {
  const proximo: Tema = temaAtual() === 'escuro' ? 'claro' : 'escuro';
  aplicarTema(proximo);
  return proximo;
}

export function modoSimplificadoAtivo(): boolean {
  return ler(CHAVE_SIMPLIFICADO) === 'sim';
}

/** Fonte maior, contraste reforçado e menos ruído por tela (seção 9.5). */
export function definirModoSimplificado(ativo: boolean): void {
  if (ativo) {
    document.documentElement.dataset['simplificado'] = 'sim';
  } else {
    delete document.documentElement.dataset['simplificado'];
  }
  gravar(CHAVE_SIMPLIFICADO, ativo ? 'sim' : 'nao');
}

/** Aplica as preferências salvas antes da primeira pintura da tela. */
export function iniciarPreferencias(): void {
  aplicarTema(temaAtual());
  definirModoSimplificado(modoSimplificadoAtivo());
}

/** Cor da marca da igreja, aplicada em runtime sobre os tokens. */
export function aplicarCorDaMarca(cor: string | null | undefined): void {
  const raiz = document.documentElement;
  if (!cor || !/^#[0-9a-fA-F]{6}$/.test(cor)) {
    raiz.style.removeProperty('--brand');
    raiz.style.removeProperty('--brand-forte');
    return;
  }
  raiz.style.setProperty('--brand', cor);
  raiz.style.setProperty('--brand-forte', escurecer(cor, 0.12));
}

function escurecer(hex: string, fator: number): string {
  const valor = Number.parseInt(hex.slice(1), 16);
  const canais = [(valor >> 16) & 255, (valor >> 8) & 255, valor & 255].map((canal) =>
    Math.max(0, Math.round(canal * (1 - fator))),
  );
  return `#${canais.map((canal) => canal.toString(16).padStart(2, '0')).join('')}`;
}
